import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';
import { GlobalService } from '../global.service';
import { Subscription } from "rxjs";
@Component({
  selector: 'app-payment-component',
  templateUrl: './payment-component.component.html',
  styleUrls: ['./payment-component.component.sass']
})
export class PaymentComponentComponent implements OnInit {
  public token:string=sessionStorage.getItem("token");
  public screen=1;
  loadObserver: Subscription;
  @Input() screenPaymentType;
  @Input() dataPay;
  @Input() payText;
  @Output() updatescreenview = new EventEmitter<any>();   
  @Output() updatepaymentview = new EventEmitter<any>();   
  public confirmNum;
  public paymentID;
  constructor(private global:GlobalService) { }
  initializeData(){
    this.global.refreshDataTo(this.token);
  }
  ngOnInit() {
    this.loadObserver = this.global.loadObserver.subscribe((value: number) => {
      this.dataLoading(value);
    });
  }
  updscreenview(){
    if(this.global.validateSession()===true){
      this.updatescreenview.emit(1);
    }
  }
  updpaymentview(){
    if(this.global.validateSession()===true){
      this.updatepaymentview.emit(3);
    }
  }
  dataLoading(sw){

  }
}
